import { getKnowledgeArticleByName, lookupEnvironmentFilesByIds } from "@/lib/api";
import { selectEffectiveEnvironmentId, useChatStore } from "@/stores/useChatStore";
import { useToastStore } from "@/stores/useToastStore";

const NOT_FOUND_MESSAGE = "記事が見つかりません。削除された可能性があります。";

/** 記事の仮想ファイルを照合し、プレビューペインに開く。失敗はトーストで知らせる。 */
export async function openKnowledgeArticle(articleId: string): Promise<void> {
	const environmentId = selectEffectiveEnvironmentId(useChatStore.getState());
	if (environmentId === null) {
		useToastStore.getState().show({ type: "error", message: "環境を選ぶと記事を開けます。" });
		return;
	}
	try {
		const [file] = await lookupEnvironmentFilesByIds(environmentId, [articleId]);
		if (!file) {
			useToastStore.getState().show({ type: "error", message: NOT_FOUND_MESSAGE });
			return;
		}
		const chat = useChatStore.getState();
		chat.mergeOpenEnvironmentFileEntries([file]);
		chat.openFilePreview(file.id);
	} catch (err) {
		console.error(err);
		useToastStore.getState().show({ type: "error", message: (err as Error).message });
	}
}

/** 記事本文の [[記事名]] のリンク先を開く。 */
export async function openKnowledgeArticleByName(name: string): Promise<void> {
	try {
		const article = await getKnowledgeArticleByName(name);
		if (article === null) {
			useToastStore.getState().show({ type: "error", message: NOT_FOUND_MESSAGE });
			return;
		}
		await openKnowledgeArticle(article.id);
	} catch (err) {
		console.error(err);
		useToastStore.getState().show({ type: "error", message: (err as Error).message });
	}
}
